/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DropzoneDialog } from 'material-ui-dropzone';
import { Box, Grid, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import fileDownload from 'js-file-download';
import Viewer from 'react-viewer';

const DropzoneV2 = ({
  onSave,
  acceptedFiles,
  showPreviews,
  maxFileSize,
  buttonText,
  errorMessage,
  filesLimit,
  disabled,
  showGridFiles,
  files,
  canDeleteFiles,
  renderFotos,
  error,
  buttonClassName,
  showImageViewer,
}) => {
  const [open, setOpen] = useState(false);
  const [openImageViewer, setOpenImageViewer] = useState(false);

  const onSaveLocal = (nextFiles) => {
    setOpen(false);
    onSave(nextFiles);
  };

  return (
    <>
      <Grid item xs={12}>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => setOpen(true)}
          disabled={disabled}
          className={buttonClassName}
        >
          {buttonText}
        </Button>
      </Grid>
      {showGridFiles && (
        <Grid item xs={12}>
          {files &&
            files.map((file, index) => (
              <React.Fragment key={index}>
                {renderFotos ? (
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item xs={12}>
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <img
                              alt=""
                              src={file.imageSrc}
                              style={{ height: 50 }}
                              onClick={() => {
                                if (showImageViewer) {
                                  setOpenImageViewer(true);
                                } else {
                                  file.onClick(file);
                                }
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <p>
                              {file.nome}
                              {canDeleteFiles && (
                                <IconButton onClick={() => file.onDelete(file)}>
                                  <DeleteIcon />
                                </IconButton>
                              )}
                            </p>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="center"
                    >
                      <p>
                        *{' '}
                        <Box
                          component="span"
                          sx={{
                            cursor: 'pointer',
                            color: 'primary.main',
                            textDecoration: 'underline',
                          }}
                          onClick={() => {
                            if (showImageViewer) {
                              setOpenImageViewer(true);
                            } else {
                              fileDownload(file.file, file.nome);
                            }
                          }}
                        >
                          {file.nome}
                        </Box>
                        {!disabled && canDeleteFiles && (
                          <IconButton onClick={() => file.onDelete(file)}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </p>
                    </Grid>
                  </Grid>
                )}
              </React.Fragment>
            ))}
          {error && (
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
              >
                <Box
                  component="p"
                  sx={{
                    color: 'error.main',
                    fontSize: 11,
                    mt: 1,
                    mx: 1.5,
                    minHeight: '1em',
                    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                    fontWeight: 400,
                    lineHeight: 1,
                    letterSpacing: 0.33,
                  }}
                >
                  {errorMessage ? errorMessage : `${buttonText} é obrigatório`}
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
      )}
      <DropzoneDialog
        open={open}
        onSave={onSaveLocal}
        acceptedFiles={acceptedFiles}
        showPreviews={showPreviews}
        maxFileSize={maxFileSize}
        onClose={() => setOpen(false)}
        filesLimit={filesLimit}
        previewText="Pré-visualização: "
        dialogTitle="Selecionar arquivos"
        cancelButtonText="Cancelar"
        submitButtonText="Salvar"
        dropzoneText="Arraste e solte um arquivo aqui ou clique"
        maxWidth="md"
        getFileAddedMessage={(fileName) =>
          `Arquivo ${fileName} adicionado com sucesso`
        }
        getFileRemovedMessage={(fileName) =>
          `Arquivo ${fileName} removido`
        }
        getFileLimitExceedMessage={(limit) =>
          `Número máximo permitido de arquivos excedido. Apenas ${limit} permitidos`
        }
        getDropRejectMessage={(rejectedFile) =>
          `Arquivo ${rejectedFile.name} foi rejeitado. Arquivo não suportado.`
        }
      />
      <Viewer
        visible={openImageViewer}
        onClose={() => setOpenImageViewer(false)}
        images={files}
        zIndex={3000}
        scalable={false}
        noImgDetails
        zoomSpeed={0.25}
      />
    </>
  );
};

DropzoneV2.propTypes = {
  acceptedFiles: PropTypes.array,
  showPreviews: PropTypes.bool,
  maxFileSize: PropTypes.number,
  buttonText: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  filesLimit: PropTypes.number,
  disabled: PropTypes.bool,
  showGridFiles: PropTypes.bool,
  files: PropTypes.array,
  canDeleteFiles: PropTypes.bool,
  renderFotos: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  showImageViewer: PropTypes.bool,
};

DropzoneV2.defaultProps = {
  acceptedFiles: ['image/jpeg', 'image/png', 'image/bmp'],
  showPreviews: true,
  maxFileSize: 5000000,
  buttonText: 'Adicionar Imagens',
  filesLimit: 10,
  disabled: false,
  showGridFiles: false,
  files: [],
  canDeleteFiles: false,
  renderFotos: false,
  error: false,
  errorMessage: null,
  showImageViewer: false,
};

export default DropzoneV2;
